import { formatNumberDe } from '@/lib/format'
import type { PositionStatus, TradeDetail } from '@/types/import'

interface TradeSectionProps {
  title: string
  trades: TradeDetail[]
  defaultOpen: boolean
}

const POSITION_BADGE: Record<PositionStatus, { label: string; cls: string }> = {
  new: { label: 'NEW POS', cls: 'bg-bernstein/20 text-bernstein' },
  matched: { label: 'MATCH', cls: 'bg-gain/20 text-gain' },
}

export function TradeSection({ title, trades, defaultOpen }: TradeSectionProps) {
  if (trades.length === 0) return null

  return (
    <details open={defaultOpen} className="hairline border bg-panel">
      <summary className="cursor-pointer list-none px-4 py-3 text-sm">
        <span className="tracked-caps text-xs text-muted">{title}</span>
        <span className="ml-2 text-ink">({trades.length})</span>
      </summary>
      <div className="hairline-t border-t">
        <table className="w-full text-xs">
          <thead className="bg-void/50 text-muted">
            <tr>
              <th className="px-3 py-2 text-left">Datum</th>
              <th className="px-3 py-2 text-left">ISIN</th>
              <th className="px-3 py-2 text-left">Ticker</th>
              <th className="px-3 py-2 text-left">Type</th>
              <th className="px-3 py-2 text-right">Qty</th>
              <th className="px-3 py-2 text-right">Price</th>
              <th className="px-3 py-2 text-right">Position</th>
            </tr>
          </thead>
          <tbody>
            {trades.map((t) => {
              const badge = POSITION_BADGE[t.position_status]
              return (
                <tr key={t.external_order_id} className="hairline-t border-t">
                  <td className="px-3 py-2 text-ink">{t.trade_date}</td>
                  <td className="px-3 py-2 font-mono text-ink">{t.isin}</td>
                  <td className="px-3 py-2 text-ink">{t.ticker}</td>
                  <td className="px-3 py-2 font-mono text-ink">{t.trade_type.toUpperCase()}</td>
                  <td className="px-3 py-2 text-right text-ink">{formatNumberDe(t.quantity, 4)}</td>
                  <td className="px-3 py-2 text-right text-ink">{formatNumberDe(t.price, 2)}</td>
                  <td className="px-3 py-2 text-right">
                    <span className={`tracked-caps px-2 py-1 text-[10px] ${badge.cls}`}>
                      {badge.label}
                    </span>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </details>
  )
}
